import React from "react";
import PropTypes from 'prop-types';
import { Chart } from "react-chartjs-2";
/* eslint-disable no-unused-vars */
import { Chart as ChartJS } from 'chart.js/auto';
/* eslint-enable no-unused-vars */

function Charts({ isMobile, type, data, options }) {
    return(
        <div style={isMobile ? { "height": "300px", "width": "auto" } : {}}>
            {type && data && options ? (
                <Chart
                    type={type}
                    data={data}        
                    options={isMobile ? { ...options, "maintainAspectRatio" : false } : options}
                />
            ) : null}
        </div>
    );
}

Charts.propTypes = {
    isMobile: PropTypes.bool,
    type: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    options: PropTypes.object.isRequired
};

export default Charts;
